import {
  GET_SCREENERS_PENDING,
  GET_SCREENERS_FULFILLED,
  GET_SCREENERS_FAILED
} from "@actions/project/screeners"
import {
  SAVE_SCREENER_FULFILLED
} from "@actions/project/screener"

const initialState = {
  status: "PENDING",
  items: []
}

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case GET_SCREENERS_PENDING:
      return {
        ...state,
        status: "PENDING"
      }

    case GET_SCREENERS_FULFILLED:
      return {
        ...state,
        status: "COMPLETE",
        items: action.payload.screeners.data
      }

    case GET_SCREENERS_FAILED:
      return {
        ...state,
        status: "ERROR"
      }
    case SAVE_SCREENER_FULFILLED:
      return {
        ...state,
        items: state.items ? state.items.map(screener =>
          screener._id === action.payload.screener._id ? action.payload.screener : screener
        ) : []
      }
    default:
      return state
  }
}
